<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
<div class="modal-header modalTitle">
    <div class="modal-title">Escalation Workflow</div>
  </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
	      <mat-radio-group (change)="onButtonChange($event)">
	        <mat-radio-button *ngFor="let button of ttypes;" [value]="button.id" [checked]="button.checked">{{button.name}}</mat-radio-button>
	      </mat-radio-group>
        </div>



         <div class="form-group">
          <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="statusSelected"
                  (change)="onstatusChange($event.target.selectedIndex)">
            <option *ngFor="let status of status" [value]="status.id">{{status.name}}</option>
          </select>
        </div> 

        <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
              (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
      </select>
    </div>
    <div class="form-group">
        <mat-radio-group (change)="onSolutionRadioChange($event)" [(ngModel)]="selectSolutionRadio">
            <mat-radio-button *ngFor="let solRadio of solutionRadioArr;" [value]="solRadio.id" [checked]="solRadio.checked">{{solRadio.name}} &nbsp;</mat-radio-button>
        </mat-radio-group>
    </div>
     <div class="form-group" [hidden]="hideGroup">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="supportGroupSelected"
              (change)="onGroupChange($event.target.selectedIndex)">
        <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
      </select>
    </div>

    </div>
     <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>